import Image from 'next/image';

import badgePediatrics from '@/assets/icons/badge-pediatrics.svg';
import badgePlatinum from '@/assets/icons/badge-platinum.svg';
import badgeSignature from '@/assets/icons/badge-signature.svg';
import { Plan } from '@/types/common';

interface PlanIconProps {
  plan: Plan;
  size?: 'sm' | 'md' | 'lg' | 'auto';
}

const Badges: Record<Plan, typeof badgeSignature> = {
  Pediatrics: badgePediatrics,
  Platinum: badgePlatinum,
  Signature: badgeSignature,
};

const SizeClasses: Record<NonNullable<PlanIconProps['size']>, string> = {
  sm: 'size-10 sm:size-[60px]',
  md: 'size-[60px]',
  lg: 'sm:size-[100px] size-[60px] ',
  auto: 'size-full',
};

export function PlanIcon({ plan, size = 'sm' }: PlanIconProps) {
  return (
    <Image
      src={Badges[plan]}
      alt={`Sollis ${plan}`}
      className={SizeClasses[size]}
      unoptimized
    />
  );
}
